import React from "react";
import { Box, Typography } from "@mui/material";
import { useParams, useLocation } from "react-router-dom";
import SteminpeLeaderboardTopPlayStudent from "../../components/leaderboards/SteminpeLeaderboardTopPlayStudent";

export default function SteamTopPlayStudentLeaderboard() {

    const { orgId, skillCode} = useParams();


    return (
        <Box>
            <SteminpeLeaderboardTopPlayStudent orgId={orgId} skillCode={skillCode} />
       </Box>
    );
}